export default function isDebugEnv() {
  if (process.env.REACT_APP_DEBUG === 'true') {
    return true
  }
  return false
}
